import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Link, Route } from 'react-router-dom';
import { Dispatch } from 'redux';
import Loading from '../../components/loading/loading';
import { Common } from '../../core/common';
import Translator from '../../core/i18n';
import { IAction, IAppState } from '../../models/action/core';
import { IMainMenuProps, MenuItem } from '../../models/pages/main-menu';
import * as Actions from '../../store/actions/mainMenu';
import * as ActionsLogin from '../../store/actions/login';
import * as ProfileAction from '../../store/actions/profile';
import Home from '../home/index';
import CCourseNavigation from '../main-navigation/course-navigation/courses-navigation';
import HeaderOptions from '../main-navigation/header-options';
import CUserHome from '../user/main';
import { MainMenuParameters, MainMenuUrlParams, AddedStaticLinkTypes } from './types.d';
import { Log } from 'ng2-logger';
import { MainMenuService } from '../../api/main-menu-service';
import { is } from 'date-fns/locale';
import { UserType } from '../../models/enums/userType';
import * as loginActions from '../../store/actions/login'
import CustomIframeModal from '../../components/iframe/iframe-modal';
import * as IFrameActions from '../../store/actions/iFrameSource';
import { SecurityContextType, SecurityPermissionType } from '../../core/SecurityContext';
import { Notification } from '../../components/notification/main';
import ReactGA from 'react-ga4';
import { ModuleItems } from '../../models/enums/moduleItems';

const T = Translator.create();
let _common: Common;
const _logger = Log.create('main-menu');
const mainMenuService = new MainMenuService();
const _lodash = require('lodash');

const ConstructorLogo = `${process.env.PUBLIC_URL}/images/constructor/constructor_logo_white.png`;
class MainMenu extends React.Component<IMainMenuProps, any> {
    public node: HTMLDivElement | null = null;
    public courseNavigationn: HTMLDivElement | null = null;
    public selectedClassName: string = '';

    constructor(props: any) {
        super(props);
        _common = new Common();
        this.setActiveMenuTab = this.setActiveMenuTab.bind(this);
        this.onClickLogout = this.onClickLogout.bind(this);
        this.state = {
            isMyGradeIframeModalOpen: false,
            isMyDocumentsIframeModalOpen: false,
            isShowAddActivity: false,
            isMobileSidebarOpen: false,
        };
    }
    public componentDidMount = () => {
        this.props.dispatch(Actions.getMainMenuData());
        this.setActiveMenuTab();
        window.onpopstate = () => {
            this.setActiveMenuTab();
        };
    };

    public componentDidUpdate() {
        this.setActiveMenuTab();
        this.setClassName();
    }

    public onClickLogout() {
        if (!this.props.isSimulate) {
            this.props.dispatch(ProfileAction.setProfileAction(null, "setProfileAction", "set"))
            this.props.dispatch(ActionsLogin.AlmsLogOut(() => {
                this.props.dispatch(ActionsLogin.logOff());
                _common.ClearAuthLocalStorage();
                window.location.href = this.props.isAlmsPlusLoginPage ? window.appSettings.DEFAULT_URL : '/';

            }));
        }
        else {
            Notification.setNotification('error', T.t('r_user_exitsimulationfirst'), 'topRight');
        }
    }

    public setActiveMenuTab(className?: string) {
        if (document.getElementsByClassName(this.selectedClassName).length > 0) {
            if (this.selectedClassName.length > 0) {
                document.getElementsByClassName(this.selectedClassName)[0].classList.remove('active');
            }

            if (className && className.length > 0) {
                ReactGA.event({
                    category: window.location.host,
                    action: 'G_MY_LESSONS',
                    label: 'G_MY_LESSONS',
                    nonInteraction: true,
                });
                this.selectedClassName = className;
                this.changeActive();
            } else {
                const isExist = this.selectedClassName.length > 0 ? true : false;
                this.setClassName();
                if (isExist) {
                    this.changeActive();
                } else {
                    this.addActive();
                }
            }
        }

    }

    public setClassName() {
        switch (window.location.pathname) {
            case MainMenuUrlParams.home:
                this.selectedClassName = MainMenuParameters.home;
                break;
            case MainMenuUrlParams.course:
                this.selectedClassName = MainMenuParameters.myCourses;
                break;
            case MainMenuUrlParams.announcement:
                this.selectedClassName = MainMenuParameters.announcements;
                break;
            case MainMenuUrlParams.forum:
                this.selectedClassName = MainMenuParameters.forum;
                break;
            case MainMenuUrlParams.message:
                this.selectedClassName = MainMenuParameters.message;
                break;
            case MainMenuUrlParams.reports:
                this.selectedClassName = MainMenuParameters.reports;
                break;
            case MainMenuUrlParams.helpdesk:
                this.selectedClassName = MainMenuParameters.helpdesk;
                break;
            case MainMenuUrlParams.adminReport:
                this.selectedClassName = MainMenuParameters.adminReport;
                break;
            case MainMenuUrlParams.adminAnnouncement:
                this.selectedClassName = MainMenuParameters.adminAnnouncement;
                break;
            case MainMenuUrlParams.adminForum:
                this.selectedClassName = MainMenuParameters.adminForum;
                break;
            case MainMenuUrlParams.adminHelpdesk:
                this.selectedClassName = MainMenuParameters.adminHelpdesk;
                break;
            case MainMenuUrlParams.adminMessage:
                this.selectedClassName = MainMenuParameters.adminMessage;
                break;
            case MainMenuUrlParams.adminSurvey:
                this.selectedClassName = MainMenuParameters.adminSurvey;
                break;
            case MainMenuUrlParams.cockpit:
                this.selectedClassName = MainMenuParameters.cockpit;
                break;
            case MainMenuUrlParams.stats:
                this.selectedClassName = MainMenuParameters.stats;
                break;
            default:
                break;
        }
    }

    public changeActive() {
        const getElement = document.getElementsByClassName(this.selectedClassName);
        if (getElement && getElement.length > 0) {
            getElement[0].classList.add('active');
        }
    }

    public addActive() {
        const divArray = document.getElementById('menu-list-continer');

        const selectedClass = this.selectedClassName;
        // tslint:disable-next-line
        const observer = new MutationObserver(function () {
            if (selectedClass.length > 0) {
                const getElement = document.getElementsByClassName(selectedClass);
                if (getElement && getElement.length > 0) {
                    getElement[0].classList.add('active');
                }
            }
            observer.disconnect();
        });

        if (divArray) {
            observer.observe(divArray, { attributes: false, childList: true, subtree: true });
        }
        this.props.dispatch(Actions.getMainMenuData('getMainMenuData', 'get'));
    }

    public handleClickOutside = (event: any) => {
        const myCourse = document.getElementById('my-courses');
        if (myCourse !== null) {
            if (!myCourse.contains(event.target) || myCourse === event.target) {
                document.removeEventListener('mousedown', this.handleClickOutside);
                // unselect the selected tab from navigation
                this.setActiveMenuTab();
                if (this.courseNavigationn) {
                    myCourse.style.display = 'none';
                    this.courseNavigationn.classList.add('fadeOut');
                    this.courseNavigationn.classList.remove('fadeIn');
                    this.courseNavigationn.classList.remove('displayBlock');
                    this.courseNavigationn.classList.add('displayNone');
                }
            }
        }
    };

    linkTypeConditions = (menuItem: MenuItem) => {
        let htmlAttributes = menuItem.htmlAttributes!.split('|')[0];
        if (!_lodash.isEmpty(menuItem.staticLink)) {
            if (_lodash.isEqual(htmlAttributes, AddedStaticLinkTypes.current)) {
                return <Link
                    onClick={this.setActiveMenuTab.bind(this, menuItem.name)}
                    to={window.appSettings.DEFAULT_URL + '/u/current?sourceUrl=' + menuItem!.staticLink}
                >
                    {T.t(menuItem.name)}
                </Link>
            } else if (_lodash.isEqual(htmlAttributes, AddedStaticLinkTypes.normal)) {
                return <a href={menuItem.staticLink ? menuItem.staticLink : ''}
                    rel="noopener noreferrer">
                    {T.t(menuItem.name)}
                </a>
            } else if (_lodash.isEqual(htmlAttributes, AddedStaticLinkTypes.newWindow)) {
                return <a href={menuItem.staticLink ? menuItem.staticLink : ''}
                    target="_blank"
                    rel="noopener noreferrer">
                    {T.t(menuItem.name)}
                </a>
            }
        } else {
            if (_lodash.isEqual(menuItem.url, "//"))
                return <Link
                    onClick={this.setActiveMenuTab.bind(this, menuItem.name)}
                    to={window.appSettings.DEFAULT_URL + '/u/Home/Index'}
                >
                    {T.t(menuItem.name)}
                </Link>
            else
                return <Link
                    onClick={this.setActiveMenuTab.bind(this, menuItem.name)}
                    to={window.appSettings.DEFAULT_URL + '/u/current?sourceUrl=' + menuItem.url}
                >
                    {T.t(menuItem.name)}
                </Link>
        }
    };

    public onClick = (event: React.MouseEvent<HTMLAnchorElement> | null) => {
        document.addEventListener('mousedown', this.handleClickOutside);
        if (event) {
            if (event.currentTarget) {
                if (event.currentTarget.dataset.parammenu === MainMenuParameters.myCourses) {
                    const myCourse = document.getElementById('my-courses');
                    if (this.courseNavigationn && myCourse) {
                        if (this.courseNavigationn.classList.contains('fadeOut')) {
                            myCourse.style.display = 'block';
                            this.courseNavigationn.classList.remove('displayNone');
                            this.courseNavigationn.classList.add('displayBlock');
                            this.courseNavigationn.classList.remove('fadeOut');
                            this.courseNavigationn.classList.add('fadeIn');
                        } else {
                            myCourse.style.display = 'none';
                            this.courseNavigationn.classList.add('fadeOut');
                            this.courseNavigationn.classList.remove('fadeIn');
                            if (this.courseNavigationn) {
                                this.courseNavigationn.classList.remove('displayBlock');
                                this.courseNavigationn.classList.add('displayNone');
                                event.currentTarget.classList.remove('active');
                            }
                        }
                    }
                }
            }
        }
    };

    public openModalJavascript() {
        return 'show()';
    }

    shouldComponentUpdate(nextProps: any, nextState: any) {
        if (nextProps != this.props) {
            return true;
        } else {
            return false;
        }
    }

    public render() {
        const buttons = Array();
        const communicationToolsButtons = Array();
        const communicationAdminButtons = Array();

        const addedButtons = Array();
        let addedSubButtons = Array();
        let addedSubSpaces = new Array<number>;
        return (
            <div style={{ position: "fixed", top: '0', width: '100%', zIndex: 99 }}>
                <Route path={window.appSettings.DEFAULT_URL + 'u/Home/Calendar'} component={Home} key="calendar" />
                <Route path={window.appSettings.DEFAULT_URL + 'u/Activity/ActivityReport'} component={Home} key="activity_report" />
                <Route path={window.appSettings.DEFAULT_URL + 'u/Question/Index'} component={Home} key="question_index" />
                <Route path={window.appSettings.DEFAULT_URL + 'u/Home/Index'} component={CUserHome} key="user_home" />
                <Route path={window.appSettings.DEFAULT_URL + 'u/Helpdesk/Index'} component={CUserHome} key="help_desk" />
                <header style={{ background: this.props.headerBackgroundImage ? 'url(' + this.props.headerBackgroundImage + ') no-repeat 50% 50% / cover' : '' }} className="navbar navbar-header navbar-expand-md d-flex justify-content-between constructor_navbar flex-nowrap menu header-min-height-res">
                    <a className="navbar-brand" href="#">
                        <Link to={this.props.userType !== UserType.Admin ? window.appSettings.DEFAULT_URL + '/u/Home/Index' : window.appSettings.DEFAULT_URL + '/u/Home/Cockpit'}>
                            <img className="navbar-image"
                                 src={this.props.organizationLogo}
                                 alt="Logo"
                                 onError={(e) => {
                                    e.currentTarget.onerror = null;
                                    e.currentTarget.src = ConstructorLogo;
                                    e.currentTarget.classList.add("default-logo");
                                }}
                                 data-imgtype={'main'} />
                        </Link>
                    </a>
                    <ul className="navbar-nav flex-row alms_navbar menu-notification">
                        <Loading spinnerId={'getMainMenuData'} width={30} />
                        {this.props.mainMenu && this.props.mainMenu.length && this.props.mainMenu.length > 0 ? (
                            this.props.mainMenu.map((m, index) => {
                                let link = null;
                                let otherLinks = null;
                                let communicationToolsLinks = null;
                                let communicationAdminLinks = null;
                                let addedLinks = null;
                                if (!_lodash.isEmpty(m.htmlAttributes)) {
                                    addedSubButtons = Array();
                                    let filteredDropDownMenuItem = this.props.mainMenu!.filter((element: any) => _lodash.isEqual(element.parentId, m.menuItemId));
                                    let filteredDropDownMenuItemByParentId = this.props.mainMenu!.filter((element: any) => _lodash.isEqual(m.parentId, element.menuItemId));
                                    //checking link relation is the main menu or another added link
                                    if (filteredDropDownMenuItem && filteredDropDownMenuItem.length > 0) {
                                        addedSubSpaces.push(filteredDropDownMenuItem.length > 2 ? (50 * filteredDropDownMenuItem.length) : 53 * filteredDropDownMenuItem.length);
                                        filteredDropDownMenuItem.forEach((subMenu, index) => {
                                            //checking link type is advanced or static
                                            if (!_lodash.isEmpty(subMenu.staticLink))
                                                addedSubButtons.push(
                                                    <> < li key={'subMenuAddedLinks-' + index} className="dropdownMenuListItems" >
                                                        {this.linkTypeConditions(subMenu)}
                                                    </li></>
                                                );
                                        });

                                        addedLinks = (
                                            <li className="addedSubButtons">
                                                <ul className="dropdown pl-0 communication_tools" >
                                                    <a
                                                        data-toggle="dropdown"
                                                        id="addedSubButtons"
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                    >
                                                        {T.t(m.name)}
                                                        <i className="material-icons ml-2 align-middle" style={{ color: 'black' }}>arrow_drop_down</i>
                                                    </a>
                                                    <div style={{ padding: '2px 0px', marginLeft: '-1px' }} id="added_sub_buttons_id" className="dropdown-menu show" aria-labelledby="addedSubButtons" key="dropdown_menu_addedSubButtons">
                                                        {addedSubButtons}
                                                    </div>
                                                </ul>
                                            </li>
                                        );
                                        addedButtons.push(
                                            <li key={'mainofSubMenusAddedLinks-' + index} className="dropdownMenuListItems" style={{ marginTop: `${addedSubSpaces.length > 1 ? addedSubSpaces[addedSubSpaces.length - 2] : '0'}px` }}>
                                                {addedLinks}
                                            </li>
                                        );
                                    } else if (m.parentId == 0 || m.parentId == null) {
                                        addedButtons.push(
                                            <li key={'mainMenuAddedLinks-' + index} className="dropdownMenuListItems" style={{ marginTop: `${addedSubSpaces.length > 0 ? addedSubSpaces[addedSubSpaces.length - 1] : '0'}px` }}>
                                                {this.linkTypeConditions(m)}
                                            </li>
                                        );
                                        if (addedSubSpaces)
                                            addedSubSpaces.splice(0, addedSubSpaces.length);
                                    } else if (m.parentId != 0 && m.parentId != null && filteredDropDownMenuItemByParentId.length == 0) {
                                        addedButtons.push(
                                            <li key={'mainMenuAddedLinks-' + index} className="dropdownMenuListItems" style={{ marginTop: `${addedSubSpaces.length > 0 ? addedSubSpaces[addedSubSpaces.length - 1] : '0'}px` }}>
                                                {this.linkTypeConditions(m)}
                                            </li>
                                        );
                                        if (addedSubSpaces)
                                            addedSubSpaces.splice(0, addedSubSpaces.length);
                                    }
                                }
                                if (m.name === MainMenuParameters.myCourses && (this.props.userType && this.props.userType !== UserType.Admin)) {
                                    link = (
                                        <a
                                            href="javascript:void(0)"
                                            className={m.name + " main_myCourses"}
                                            onClick={e => {
                                                this.onClick(e);
                                                this.setActiveMenuTab(m.name);
                                            }}
                                            data-parammenu={m.name}
                                            tabIndex={0}
                                        >
                                            {T.t(m.name)}
                                        </a>
                                    );
                                    otherLinks = (
                                        <a
                                            href="javascript:void(0)"
                                            className={m.name + " other_myCourses"}
                                            onClick={e => {
                                                this.onClick(e);
                                                this.setActiveMenuTab(m.name);
                                            }}
                                            data-parammenu={m.name}
                                        >
                                            {T.t(m.name)}
                                        </a>
                                    );
                                } else if (m.name === MainMenuParameters.home && (this.props.userType && this.props.userType !== UserType.Admin)) {
                                    link = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " main_home"}
                                            to={window.appSettings.DEFAULT_URL + '/u/Home/Index'}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                    otherLinks = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " other_home"}
                                            to={window.appSettings.DEFAULT_URL + '/u/Home/Index'}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                    buttons.push(
                                        <li key={'mainMenuOther-' + index} className="dropdownMenuListItems">
                                            {otherLinks}
                                        </li>
                                    );
                                    otherLinks = (
                                        <li className="other_added">
                                            <ul className="dropdown pl-0 communication_tools"  >
                                                <a
                                                    data-toggle="dropdown"
                                                    id="addedButtons"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                    tabIndex={0}
                                                    href="javascript:void(0)"
                                                >
                                                    {T.t('r_gen_other')}
                                                    <i className="material-icons ml-2 align-middle" style={{ color: 'black' }}>arrow_drop_down</i>
                                                </a>
                                                <div id="added_buttons_id" className="dropdown-menu show" aria-labelledby="addedButtons" key="dropdown_menu_addedButtons">
                                                    {addedButtons}
                                                </div>
                                            </ul>
                                        </li>
                                    );
                                } else if (m.name === MainMenuParameters.cockpit && ((this.props.userType && (this.props.userType === UserType.Admin || this.props.userType === UserType.ProgramAdmin)) || (this.props.userType === UserType.Teacher && (this.props.organizationId && Common.HasPermission(SecurityContextType.Organization, SecurityPermissionType.Core_CockpitView, this.props.organizationId))))) {
                                    link = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " main_cockpit"}
                                            to={window.appSettings.DEFAULT_URL + '/u/Home/Cockpit'}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                    otherLinks = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " other_cockpit"}
                                            to={window.appSettings.DEFAULT_URL + '/u/Home/Cockpit'}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                    buttons.push(
                                        <li key={'mainMenuOther-' + index} className="dropdownMenuListItems">
                                            {otherLinks}
                                        </li>
                                    );
                                    otherLinks = (
                                        <li className="other_added">
                                            <ul className="dropdown pl-0 communication_tools"  >
                                                <a
                                                    data-toggle="dropdown"
                                                    id="addedButtons"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                    tabIndex={0}
                                                    href="javascript:void(0)"
                                                >
                                                    {T.t('r_gen_other')}
                                                    <i className="material-icons ml-2 align-middle" style={{ color: 'black' }}>arrow_drop_down</i>
                                                </a>
                                                <div id="added_buttons_id" className="dropdown-menu show" aria-labelledby="addedButtons" key="dropdown_menu_addedButtons">
                                                    {addedButtons}
                                                </div>
                                            </ul>
                                        </li>
                                    );
                                }
                                else if (m.name === MainMenuParameters.stats && (this.props.userType && this.props.userType === UserType.Admin)) {
                                    link = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " main_stats"}
                                            to={window.appSettings.DEFAULT_URL + '/u/Stats'}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                    otherLinks = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " other_stats"}
                                            to={window.appSettings.DEFAULT_URL + '/u/Stats'}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                } else if (this.props.moduleItems.includes(ModuleItems.Announcement) && m.name === MainMenuParameters.announcements && (this.props.userType && this.props.userType !== UserType.Admin)) {
                                    communicationToolsLinks = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " main_announcements"}
                                            to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                        >
                                            {T.t(m.name)}
                                            {
                                                (this.props.menuAnnouncementUnreadCount === true) &&
                                                <span className='notify-dot-red'></span>
                                            }
                                        </Link>
                                    );
                                    communicationToolsButtons.push(
                                        <li key={'mainMenuCommunicationTools-' + index} className="dropdownMenuListItems">
                                            {communicationToolsLinks}
                                        </li>
                                    );
                                } else if (m.name === MainMenuParameters.adminAnnouncement && (this.props.userType && this.props.userType === UserType.Admin)) {
                                    communicationAdminLinks = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " main_announcements"}
                                            to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                        >
                                            {T.t(m.name)}
                                            {
                                                (this.props.menuAnnouncementUnreadCount === true) &&
                                                <span className='notify-dot-red'></span>
                                            }
                                        </Link>
                                    );
                                } else if (this.props.moduleItems.includes(ModuleItems.Messaging) && m.name === MainMenuParameters.message && (this.props.userType && this.props.userType !== UserType.Admin)) {
                                    communicationToolsLinks = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " main_message"}
                                            to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                        >
                                            {T.t(m.name)}
                                            {
                                                (this.props.menuMessageUnreadCount === true) &&
                                                <span className='notify-dot-red'></span>
                                            }
                                        </Link>
                                    );
                                    communicationToolsButtons.push(
                                        <li key={'mainMenuCommunicationTools-' + index} className="dropdownMenuListItems">
                                            {communicationToolsLinks}
                                        </li>
                                    );
                                } else if (m.name === MainMenuParameters.adminMessage && (this.props.userType && this.props.userType === UserType.Admin)) {
                                    communicationAdminLinks = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " main_message"}
                                            to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                        >
                                            {T.t(m.name)}
                                            {
                                                (this.props.menuMessageUnreadCount === true) &&
                                                <span className='notify-dot-red'></span>
                                            }
                                        </Link>
                                    );
                                } else if (m.name === MainMenuParameters.adminSurvey && (this.props.userType && this.props.userType === UserType.Admin)) {
                                    communicationAdminLinks = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " main_survey"}
                                            to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                } else if (this.props.moduleItems.includes(ModuleItems.Forum) && m.name === MainMenuParameters.forum && (this.props.userType && this.props.userType !== UserType.Admin)) {
                                    communicationToolsLinks = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " main_forum a"}
                                            to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                    communicationToolsButtons.push(
                                        <li key={'mainMenuCommunicationTools-' + index} className="dropdownMenuListItems">
                                            {communicationToolsLinks}
                                        </li>
                                    );
                                } else if (m.name === MainMenuParameters.adminForum && (this.props.userType && this.props.userType === UserType.Admin)) {
                                    communicationAdminLinks = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " main_forum"}
                                            to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                } else if (m.name === MainMenuParameters.calendar && (this.props.userType && this.props.userType !== UserType.Admin)) {
                                    link = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " main_calendar"}
                                            to={window.appSettings.DEFAULT_URL + '/u/calendar'}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                    otherLinks = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " other_calendar"}
                                            to={window.appSettings.DEFAULT_URL + '/u/calendar'}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                    if (this.props.userType && this.props.userType === UserType.Student) {
                                        otherLinks = (
                                            <li className="other_communicationTools">
                                                <ul className="dropdown pl-0 communication_tools"  >
                                                    <a
                                                        data-toggle="dropdown"
                                                        id="communicationToolsButtons"
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                        tabIndex={0}
                                                        href="javascript:void(0)"
                                                    >
                                                        {T.t('r_home_communication_tools')}
                                                        {
                                                            (this.props.menuMessageUnreadCount === true || this.props.menuAnnouncementUnreadCount === true) &&
                                                            <span className='notify-dot-red'></span>
                                                        }
                                                        <i className="material-icons ml-2 align-middle" style={{ color: 'black' }}>arrow_drop_down</i>
                                                    </a>
                                                    <div id="communication_tools_id" className="dropdown-menu show" aria-labelledby="communicationToolsButtons" key="dropdown_menu_communicationToolsButtons">
                                                        {communicationToolsButtons}
                                                    </div>
                                                </ul>
                                            </li>
                                        );
                                    }
                                }
                                else if (this.props.moduleItems.includes(ModuleItems.Help) && m.name === MainMenuParameters.helpdesk && (this.props.userType && this.props.userType !== UserType.Admin)) {
                                    communicationToolsLinks = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " main_helpdesk"}
                                            to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                    communicationToolsButtons.push(
                                        <li key={'mainMenuCommunicationTools-' + index} className="dropdownMenuListItems">
                                            {communicationToolsLinks}
                                        </li>
                                    );
                                }
                                else if (m.name === MainMenuParameters.adminHelpdesk && (this.props.userType && this.props.userType === UserType.Admin)) {
                                    communicationAdminLinks = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " main_helpdesk"}
                                            to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                }
                                else if (m.name === MainMenuParameters.questionBank) {
                                    link = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " main_questionBank"}
                                            to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                    otherLinks = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " other_questionBank"}
                                            to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                    buttons.push(
                                        <li key={'mainMenuOther-' + index} className="dropdownMenuListItems">
                                            {otherLinks}
                                        </li>
                                    );
                                    otherLinks = (
                                        <li className="other_communicationTools">
                                            <ul className="dropdown pl-0 communication_tools"  >
                                                <a
                                                    data-toggle="dropdown"
                                                    id="communicationToolsButtons"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                    tabIndex={0}
                                                >
                                                    {T.t('r_home_communication_tools')}
                                                    {
                                                        (this.props.menuMessageUnreadCount === true || this.props.menuAnnouncementUnreadCount === true) &&
                                                        <span className='notify-dot-red'></span>
                                                    }
                                                    <i className="material-icons ml-2 align-middle" style={{ color: 'black' }}>arrow_drop_down</i>
                                                </a>
                                                <div id="communication_tools_id" className="dropdown-menu show" aria-labelledby="communicationToolsButtons" key="dropdown_menu_communicationToolsButtons">
                                                    {communicationToolsButtons}
                                                </div>
                                            </ul>
                                        </li>
                                    );
                                }
                                if (m.name === MainMenuParameters.reports) {
                                    link = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " main_reports"}
                                            to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                    otherLinks = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " other_reports"}
                                            to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                }
                                if (m.name === MainMenuParameters.adminReport && (this.props.userType && this.props.userType === UserType.Admin)) {
                                    link = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " main_reports"}
                                            to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                    otherLinks = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " other_reports"}
                                            to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                }
                                if (m.name === MainMenuParameters.gradeChart && (this.props.userType && this.props.userType !== UserType.Admin)) {
                                    link = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " main_gradeChart"}
                                            to={window.appSettings.DEFAULT_URL + '/u' + '/mygrades/index'}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                    otherLinks = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " other_gradeChart"}
                                            to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                }
                                if (m.name === MainMenuParameters.myDocuments && (this.props.userType && this.props.userType !== UserType.Student)) {
                                    link = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " main_myDocuments"}
                                            to={window.appSettings.DEFAULT_URL + '/u' + "/files/index"}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                    otherLinks = (
                                        <Link
                                            onClick={this.setActiveMenuTab.bind(this, m.name)}
                                            className={m.name + " other_myDocuments"}
                                            to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                        >
                                            {T.t(m.name)}
                                        </Link>
                                    );
                                }
                                if (((m.name === MainMenuParameters.adminAnnouncement && this.props.moduleItems.includes(ModuleItems.Announcement)) || (this.props.moduleItems.includes(ModuleItems.Forum) && m.name === MainMenuParameters.adminForum) ||(this.props.moduleItems.includes(ModuleItems.Help) && m.name === MainMenuParameters.adminHelpdesk) || (this.props.moduleItems.includes(ModuleItems.Messaging) && m.name === MainMenuParameters.adminMessage) || m.name === MainMenuParameters.adminSurvey) && (this.props.userType && this.props.userType === UserType.Admin)) {
                                    communicationAdminButtons.push(
                                        <li key={'mainMenuCommunicationAdmin-' + index} className="dropdownMenuListItems">
                                            {communicationAdminLinks}
                                        </li>
                                    );
                                }
                                buttons.push(
                                    <li key={'mainMenuOther-' + index} className="dropdownMenuListItems">
                                        {otherLinks}
                                    </li>
                                );
                                return (
                                    <>
                                        {
                                            link !== null ? (
                                                <li
                                                    key={'mainMenu-' + index}
                                                    className={
                                                        m.name !== MainMenuParameters.home && m.name !== MainMenuParameters.cockpit
                                                            ? m.name === MainMenuParameters.announcements
                                                                ? this.props.menuAnnouncementUnreadCount
                                                                    ? 'dropdownMenuButtonCollapse nav-item new-notification'
                                                                    : 'dropdownMenuButtonCollapse nav-item'
                                                                : m.name === MainMenuParameters.message
                                                                    ? this.props.menuMessageUnreadCount
                                                                        ? 'dropdownMenuButtonCollapse nav-item new-notification'
                                                                        : 'dropdownMenuButtonCollapse nav-item'
                                                                    : 'dropdownMenuButtonCollapse nav-item'
                                                            : ''
                                                    }
                                                >
                                                    {link}
                                                </li>
                                            ) : (
                                                ''
                                            )}
                                    </>
                                );
                            })
                        ) : this.props.mainMenu ? (
                            ''
                        ) : (
                            <h3>{T.t('r_select_noRecord')}</h3>
                        )}
                        {/* {(this.props.userType && this.props.userType !== UserType.Admin) &&
                            <li className="main_communicationTools">
                                <ul className="dropdown pl-0 communication_tools"   >
                                    <a
                                        data-toggle="dropdown"
                                        id="communicationToolsButtons"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        tabIndex={0}
                                        href="javascript:void(0)"

                                    >
                                        {T.t('r_home_communication_tools')}c
                                        {
                                            (this.props.menuMessageUnreadCount===true || this.props.menuAnnouncementUnreadCount===true) &&
                                                <span className='notify-dot-red'></span>
                                        }
                                        <i className="material-icons ml-2 align-middle">arrow_drop_down</i>
                                    </a>
                                    <div className="dropdown-menu" aria-labelledby="communicationToolsButtons" key="dropdown_menu_communicationToolsButtons">
                                        {communicationToolsButtons}{this.props.moduleItems}
                                    </div>
                                </ul>
                            </li>
                        } */}









                        {(this.props.userType && this.props.userType !== UserType.Admin) &&
                            (
                                <li className="main_communicationTools">
                                    <ul className="dropdown pl-0 communication_tools">
                                        <a
                                            data-toggle="dropdown"
                                            id="communicationToolsButtons"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                            tabIndex={0}
                                            href="javascript:void(0)"
                                        >
                                            {T.t('r_home_communication_tools')}
                                            {(this.props.menuMessageUnreadCount === true || this.props.menuAnnouncementUnreadCount === true) &&
                                                <span className='notify-dot-red'></span>
                                            }
                                            <i className="material-icons ml-2 align-middle">arrow_drop_down</i>
                                        </a>
                                        <div className="dropdown-menu" aria-labelledby="communicationToolsButtons" key="dropdown_menu_communicationToolsButtons">
                                            {communicationToolsButtons}
                                        </div>
                                    </ul>
                                </li>
                            )
                        }



















                        {(this.props.userType && this.props.userType === UserType.Admin) &&
                            <li tabIndex={0}>
                                <ul className="dropdown pl-0 communication_tools" tabIndex={0} >
                                    <a
                                        data-toggle="dropdown"
                                        id="communicationAdminButtons"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        {T.t('r_home_communication')}
                                        <i className="material-icons ml-2 align-middle">arrow_drop_down</i>
                                    </a>
                                    <div className="dropdown-menu" aria-labelledby="communicationAdminButtons" key="dropdown_menu_communicationAdminButtons">
                                        {communicationAdminButtons}
                                    </div>
                                </ul>
                            </li>
                        }
                        {
                            addedButtons && addedButtons.length > 0 ?

                                <li className="main_added">
                                    <ul className="dropdown pl-0 communication_tools"  >
                                        <a
                                            data-toggle="dropdown"
                                            id="addedButtons"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                            tabIndex={0}
                                            href="javascript:void(0)"
                                        >
                                            {T.t('r_gen_other')}
                                            <i className="material-icons ml-2 align-middle">arrow_drop_down</i>
                                        </a>
                                        <div className="dropdown-menu" style={{ overflowX: 'auto', overflowY: 'scroll' }} aria-labelledby="addedButtons" key="dropdown_menu_addedButtons">
                                            {addedButtons}
                                        </div>
                                    </ul>
                                </li> : null

                        }

                        {(this.props.userType && this.props.userType !== UserType.Admin) &&
                            <li tabIndex={0}>
                                <ul className="dropdown pl-0 others_list">
                                    <a
                                        data-toggle="dropdown"
                                        className="dropdownMenuButtonOther"
                                        id="dropdownMenuButtonOther"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        key={Math.random() * 10000}
                                    >
                                        <span className="navbar-toggler-icon ml-2 align-middle"></span>
                                    </a>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButtonOther" key="dropdown_menu">
                                        {buttons}
                                    </div>
                                </ul>
                            </li>
                        }
                    </ul>
                    <HeaderOptions isMessageModelOpen={this.props.isMessageModelOpen} triggerMessageModal={this.props.triggerMessageModal} />
                    <button className="navbar-toggler" type="button" data-toggle="modal" data-target="#sidebarModal">
                        <span className="navbar-toggler-icon" />
                    </button>
                </header>
                {this.props.mainMenu && this.props.mainMenu.length && this.props.mainMenu.length > 0 ? (
                    <div
                        ref={e => (e !== null ? (this.courseNavigationn = e) : null)}
                        id="courseNavigationn"
                        className="displayNone animated fadeOut mainSubCourseNav "
                    >
                        <CCourseNavigation />
                    </div>
                ) : ''}
                <div className="container-fluid alms_mobile_sidebar " >
                    <div className="modal left modal-from-right fade menu" id="sidebarModal" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog position-fixed m-auto" role="document">
                            <button type="button" className="sidebar_close" data-dismiss="modal" aria-label="Close">
                                <i className="material-icons" style={{ color: 'rgb(0, 0, 0)' }}>close</i>
                                <span>Kapat</span>
                            </button>
                            <div className="modal-content h-100 min-w-100">
                                <div className="modal-body p-3">
                                    <div className="nav flex-column">
                                        <div className="row" style={{ marginTop: '-20px' }}>
                                            <div className="col-12" style={{ paddingLeft: '0', height: '100vh' }}>
                                                <Route path={window.appSettings.DEFAULT_URL + 'u/Home/Calendar'} component={Home} key="calendar" />
                                                <Route path={window.appSettings.DEFAULT_URL + 'u/Activity/ActivityReport'} component={Home} key="activity_report" />
                                                <Route path={window.appSettings.DEFAULT_URL + 'u/Question/Index'} component={Home} key="question_index" />
                                                <Route path={window.appSettings.DEFAULT_URL + 'u/Home/Index'} component={CUserHome} key="user_home" />
                                                <Route path={window.appSettings.DEFAULT_URL + 'u/Helpdesk/Index'} component={CUserHome} key="help_desk" />
                                                <ul className=" sidebar_menu">
                                                    {this.props.mainMenu && this.props.mainMenu.length && this.props.mainMenu.length > 0 ? (
                                                        this.props.mainMenu.map((m, index) => {
                                                            let link = null;
                                                            if (m.name === MainMenuParameters.myCourses) {
                                                                link = (
                                                                    <Link
                                                                        onClick={this.setActiveMenuTab.bind(this, m.name)}
                                                                        className={m.name}
                                                                        to={window.appSettings.DEFAULT_URL + '/u/mycourse'}
                                                                    >
                                                                        {T.t(m.name)}
                                                                    </Link>
                                                                );
                                                            }
                                                            else if (m.name === MainMenuParameters.gradeChart && (this.props.userType && this.props.userType !== UserType.Admin)) {

                                                                link = (
                                                                            <Link
                                                                                onClick={this.setActiveMenuTab.bind(this, m.name)}
                                                                                className={m.name + " main_gradeChart"}
                                                                                to={window.appSettings.DEFAULT_URL + '/u' + '/mygrades/index'}
                                                                            >
                                                                                {T.t(m.name)}
                                                                            </Link>
                                                                        );
                                                            }

                                                            else if (m.name === MainMenuParameters.home) {
                                                                link = (
                                                                    <Link
                                                                        onClick={this.setActiveMenuTab.bind(this, m.name)}
                                                                        className={m.name}
                                                                        to={window.appSettings.DEFAULT_URL + '/u/Home/Index'}
                                                                    >
                                                                        {T.t(m.name)}
                                                                    </Link>
                                                                );
                                                            } else if (m.name === MainMenuParameters.cockpit) {
                                                                link = null;
                                                            } else if (m.name === MainMenuParameters.stats && this.props.userType && this.props.userType === UserType.Admin) {
                                                                link = (
                                                                    <Link
                                                                        onClick={this.setActiveMenuTab.bind(this, m.name)}
                                                                        className={m.name}
                                                                        to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                                                    >
                                                                        {T.t(m.name)}
                                                                    </Link>
                                                                );;
                                                            } else if (this.props.moduleItems.includes(ModuleItems.Announcement) && m.name === MainMenuParameters.announcements) {
                                                                link = (
                                                                    <Link
                                                                        onClick={this.setActiveMenuTab.bind(this, m.name)}
                                                                        className={m.name}
                                                                        to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                                                    >
                                                                        {T.t(m.name)}
                                                                    </Link>
                                                                );
                                                            } else if (this.props.moduleItems.includes(ModuleItems.Messaging) && m.name === MainMenuParameters.message) {
                                                                link = (
                                                                    <Link
                                                                        onClick={this.setActiveMenuTab.bind(this, m.name)}
                                                                        className={m.name}
                                                                        to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                                                    >
                                                                        {T.t(m.name)}
                                                                    </Link>
                                                                );
                                                            } else if (this.props.moduleItems.includes(ModuleItems.Forum) && m.name === MainMenuParameters.forum) {
                                                                link = (
                                                                    <Link
                                                                        onClick={this.setActiveMenuTab.bind(this, m.name)}
                                                                        className={m.name}
                                                                        to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                                                    >
                                                                        {T.t(m.name)}
                                                                    </Link>
                                                                );
                                                            } else if (this.props.moduleItems.includes(ModuleItems.Help) && m.name === MainMenuParameters.helpdesk) {
                                                                link = (
                                                                    <Link
                                                                        onClick={this.setActiveMenuTab.bind(this, m.name)}
                                                                        className={m.name}
                                                                        to={window.appSettings.DEFAULT_URL + '/u' + m.url}
                                                                    >
                                                                        {T.t(m.name)}
                                                                    </Link>
                                                                );
                                                            }
                                                            return (
                                                                <>
                                                                    {
                                                                        link !== null ? (
                                                                            <li


                                                                                key={'mainMenu-' + index}

                                                                                className={
                                                                                    m.name !== MainMenuParameters.home && m.name !== MainMenuParameters.cockpit
                                                                                        ? 'dropdownMenuButtonCollapse nav-item '
                                                                                        : ''
                                                                                }
                                                                            >
                                                                                {link}
                                                                            </li>
                                                                        ) : (
                                                                            ''
                                                                        )}
                                                                </>
                                                            );
                                                        })
                                                    ) : this.props.mainMenu ? (
                                                        ''
                                                    ) : (
                                                        <h3>{T.t('r_select_noRecord')}</h3>
                                                    )}


                                                </ul>
                                                <div className='mobile-notification'>
                                                    <div className='d-flex align-item-center justify-content-center '>
                                                        <HeaderOptions unreadMessageCount={this.props.unreadMessageCount} unreadAnnounceCount={this.props.unreadAnnounceCount} />

                                                    </div>
                                                    <div className='mobile-logout' style={{ marginTop: 40 }}>
                                                        <a onClick={this.onClickLogout} href="javascript:;" className="dd-btn">
                                                            <i className="material-icons">exit_to_app</i>
                                                            {T.t('r_logout_close_button')}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IMainMenuProps): IMainMenuProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IMainMenuProps = Object.assign({}, ownProps, {
        mainMenu: state.mainMenuRoot.mainMenu,
        organizationLogo: state.login.login.organizationLogo,
        headerBackgroundImage: state.login.login.headerBackgroundImage,
        mainMenuIsLoading: state.mainMenuRoot.mainMenuIsLoading,
        menuAnnouncementUnreadCount: state.announcement.mainMenuAnnouncementUnread,
        menuMessageUnreadCount: state.message.mainMenuMessageUnread,
        iFrameSource: state.iFrame.iFrameSource,
        organizationId: state.login.identitiy.organizationId,
        timeZone: state.login.identitiy.timeZone,
        userType: state.login.identitiy.userType,
        unreadMessageCount: state.message.unreadMessageCount,
        unreadAnnounceCount: state.announcement.unreadAnnounceCount,
        isAlmsPlusLoginPage: state.login.login.isAlmsPlusLoginPage,
        moduleItems: state.login.login.moduleItems
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.mainMenuRoot.mainMenu === prev.mainMenuRoot.mainMenu &&
        next.login.login === prev.login.login &&
        next.login.identitiy.organizationId === prev.login.identitiy.organizationId &&
        next.login.identitiy.userType === prev.login.identitiy.userType &&
        next.login.identitiy.timeZone === prev.login.identitiy.timeZone &&
        next.iFrame.iFrameSource === prev.iFrame.iFrameSource &&
        next.message.mainMenuMessageUnread === prev.message.mainMenuMessageUnread &&
        next.announcement.mainMenuAnnouncementUnread === prev.announcement.mainMenuAnnouncementUnread &&
        next.message.unreadMessageCount === prev.message.unreadMessageCount &&
        next.announcement.unreadAnnounceCount === prev.announcement.unreadAnnounceCount;
    return ret;
};
const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CMainMenu = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(MainMenu);

export default CMainMenu;
